import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, LogOut, LogIn, User } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../contexts/AuthContext';

const Navigation = ({ showBackButton = false, backTo = '/' }) => {
  const navigate = useNavigate();
  const { user, isAuthenticated, login, logout } = useAuth();

  return (
    <nav className="border-b border-border backdrop-blur-sm bg-background/95 sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            {showBackButton && (
              <Button
                variant="ghost"
                size="icon"
                onClick={() => navigate(backTo)}
                className="hover:bg-accent/10 hover:text-accent"
              >
                <ArrowLeft className="w-5 h-5" />
              </Button>
            )}
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-4 hover:opacity-80 transition-opacity bg-transparent border-none cursor-pointer"
            >
              <img src="/logo.png" alt="Shoot Base" className="h-14 md:h-20 w-auto object-contain" />
              <h1 className="text-xl md:text-2xl font-bold text-accent" style={{ fontFamily: 'Playfair Display, serif' }}>
                Shoot Base
              </h1>
            </button>
          </div>

          <div className="flex items-center gap-3">
            {/* Navigation Links */}
            <Button 
              variant="ghost" 
              className="hidden md:inline-flex hover:text-accent"
              onClick={() => navigate('/about')}
            >
              About
            </Button>
            <Button 
              variant="ghost" 
              className="hidden md:inline-flex hover:text-accent" 
              onClick={() => navigate('/discover')}
            >
              Discover Projects
            </Button>
            <Button 
              variant="ghost" 
              className="hidden md:inline-flex hover:text-accent" 
              onClick={() => navigate('/departments')}
            >
              Departments
            </Button>
            <Button 
              variant="ghost" 
              className="hidden md:inline-flex hover:text-accent" 
              onClick={() => navigate('/post-project')}
            >
              Create Hiring Post
            </Button>

            {/* User Profile Section */}
            {isAuthenticated && user ? (
              <>
                {/* Clickable User Profile */}
                <button
                  onClick={() => navigate(`/profile/${user.user_id}`)}
                  className="flex items-center gap-2 px-3 py-2 rounded-lg bg-accent/10 hover:bg-accent/20 transition-colors cursor-pointer border-none"
                  title="View Profile"
                >
                  {user.picture ? (
                    <img 
                      src={user.picture} 
                      alt={user.name} 
                      className="w-8 h-8 rounded-full border-2 border-accent/30"
                    />
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-accent flex items-center justify-center text-white font-bold">
                      {user.name?.charAt(0).toUpperCase()}
                    </div>
                  )}
                  <span className="text-sm font-medium hidden md:inline">{user.name}</span>
                </button>

                {/* Admin Dashboard Link */}
                {user.is_admin && (
                  <Button 
                    variant="ghost"
                    size="sm" 
                    className="hidden md:inline-flex hover:text-accent"
                    onClick={() => navigate('/admin')}
                  >
                    Admin
                  </Button>
                )}

                {/* Logout Button */}
                <Button 
                  variant="ghost"
                  size="sm" 
                  className="hidden md:inline-flex hover:text-accent gap-2"
                  onClick={logout}
                >
                  <LogOut className="w-4 h-4" />
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button 
                  variant="ghost" 
                  size="sm" 
                  className="hidden md:inline-flex hover:text-accent gap-2" 
                  onClick={login}
                >
                  <LogIn className="w-4 h-4" />
                  Sign in with Google
                </Button>
                <Button 
                  className="bg-accent hover:bg-accent/90 text-primary-foreground" 
                  onClick={login}
                >
                  Join Now
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
